import { Pipe, PipeTransform } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { TypedFormControl } from 'osn-shared';

@Pipe({
  name: 'errorIfMissing',
  pure: false,
})
export class ErrorIfMissingPipe implements PipeTransform {
  public transform(formControl: UntypedFormControl | TypedFormControl<unknown>, errorText: string): string | undefined {
    if (!formControl || !errorText) {
      return undefined;
    }

    return formControl.touched && formControl.hasError('required') ? errorText : undefined;
  }
}
